import InlineTable from './inlinetable.vue';

InlineTable.install = function (Vue) {
    Vue.component(InlineTable.name, InlineTable);
};

export default InlineTable;